<template>
    <article class="a-as-article-footer">
        <p
            v-show="footerData.source"
            class="a-as-article-footer__desc">
            <div v-html="footerData.source"></div>
            <div v-html="footerData.subString"></div>
        </p>
        <arrow-button
            v-if="footerData.button"
            :link-data="footerData.button"
            :colorClass="arrowColor"/>
    </article>
</template>

<script>
    import ArrowButton from './ArrowButton'

    export default {
        name: 'ArticleFooter',
        data() {
            return {
                arrowColor: 'black-arrow'
            }
        },
        props: {
            footerData: Object,
        },
        components: {
            ArrowButton
        }
    }
</script>
